import {Pill} from '@wandb/weave/components/Tag';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React from 'react';

import {WeaveRoleType} from './util';

type WeaveRoleTypeProps = {
  currentWeaveRole: WeaveRoleType | undefined;
  isEnterprisePlan?: boolean;
};

export const WeaveRoleTypePill = ({
  currentWeaveRole: currentWeaveRole,
  isEnterprisePlan = false,
}: WeaveRoleTypeProps) => {
  if (!currentWeaveRole) {
    return null;
  }

  const PillComponent = (
    <Pill
      label={currentWeaveRole}
      icon={
        currentWeaveRole === WeaveRoleType.VIEWER
          ? 'show-visible'
          : 'checkmark-circle'
      }
      color="teal"
    />
  );

  return (
    <Tailwind>
      {currentWeaveRole === WeaveRoleType.NOACCESS ? (
        <span className="text-gray-450 ">{currentWeaveRole}</span>
      ) : isEnterprisePlan ? (
        <TooltipDeprecated
          position="top center"
          className="flex items-center"
          trigger={<div>{PillComponent}</div>}>
          <Tailwind>
            <div className="flex items-center">
              Change organization role to change access
            </div>
          </Tailwind>
        </TooltipDeprecated>
      ) : (
        <div>{PillComponent}</div>
      )}
    </Tailwind>
  );
};
